import React from "react";
import { ISearchValue, SearchTypeEnum } from "@/components/YhPageHeader/Types";
import { YhPageHeader } from "@/components/YhPageHeader";
import useGlobalModel from "@/model/globalModel";
import { useWebSiteModel } from "../webSiteModel";

export function PageHeader() {
	const {
		searchParam,
		updateSearchParam,
		resetSearchParam,
		loadData
	} = useWebSiteModel();

	// const searchFields = [
	//     {
	//         type: SearchTypeEnum.Input,
	//         placeholder: "供应商编码",
	//         fieldName: "code",
	//     }
	// ]

	return (
		<YhPageHeader
			title="站点信息管理"
		// searchValues={searchParam as ISearchValue}
		// searchFields={searchFields}
		// onChange={updateSearchParam}
		// triggerSearch
		// handleSearch={(val = {}) => loadData({ pageNum: 1 }, { ...searchParam, ...val })}
		// handleReset={resetSearchParam}
		/>
	);
}